import { useNavigation } from "@react-navigation/native";
import { useCallback } from "react";
import { FlatList, ListRenderItem } from "react-native";

import { Callout, CalloutRefresh, ReviewItem } from "../components";
import { LoadingScreen } from "./loading";
import {
  getDateFromServerTimestamp,
  Review,
  useReviews,
  useUser,
} from "../services";

export function ReviewsScreen() {
  // Data
  const {
    data: user,
    isLoading: isUserLoading,
    refetch: refetchUser,
  } = useUser();
  const { data: reviews } = useReviews();

  // Vars
  const navigation = useNavigation();

  const renderItem: ListRenderItem<Review> = ({ item }) => renderListItem(item);

  const renderListItem = ({
    id,
    comments: text,
    created_at: createdAt,
    score,
  }: Review) => {
    return (
      <ReviewItem
        {...{
          key: id,
          score,
          message: text,
          date: createdAt ? new Date(createdAt) : null,
        }}
      />
    );
  };

  // Handlers
  const goToPremium = useCallback(() => {
    navigation.navigate("Premium");
  }, [navigation]);

  // Render
  if (isUserLoading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <CalloutRefresh onRefresh={refetchUser} />;
  }

  if (!user.premium) {
    return (
      <Callout
        icon="pencil-box-multiple"
        message={`You have ${user.reviews_count} reviews.|To see your reviews you need a Premium subscription`}
        action="Buy Premium"
        onPress={goToPremium}
      />
    );
  }

  return (
    <FlatList
      data={reviews}
      ListEmptyComponent={
        <Callout icon="pencil-box-multiple" message="You have no review yet" />
      }
      renderItem={renderItem}
    />
  );
}
